// extracted by mini-css-extract-plugin
export const root = "header-modules--root--11RzA";
export const rootNotFixed = "header-modules--rootNotFixed--2Q6v5";
export const rootFixed = "header-modules--rootFixed--M76Yq";
export const categoryLink = "header-modules--categoryLink--3UiUS";
export const logoWrapper = "header-modules--logoWrapper--2lBqB";
export const fadeIn = "header-modules--fade-in--PmRwr";